module.exports = __webpack_public_path__ + "img/5910366.5e384b5a.png";